import { years } from '../../../../Common/Filters/Filters';
import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerYearPercentageChart = () => {
    const { chartData, subtitles, colors } = useServicesChartsDataContext();

    const series = subtitles.map((item, index) => {
        const data = years.map((year) => {
            const found = chartData.counterYear.find(
                (counter) => counter.ano_competencia === year
            );

            return found
                ? (index === 0
                      ? Number(found.percentage_acommodations)
                      : Number(found.percentage_permanences)
                  ).toFixed(2)
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => `${val}%`
                },
                max: 100
            },
            xaxis: {
                categories: years || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors,
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerYearPercentageChart;
